import React, { useState } from 'react';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Form,
} from 'react-bootstrap';
import { FilterList, Clear } from '@mui/icons-material';
import { PROJECT_STATUS_OPTIONS } from '../../config_and_helpers/config';
import './ProjectFilterComponent.css';

/**
 * Component for filtering projects based on status
 * @param {Object} filters - Current filter state
 * @param {Function} setFilters - Function to update filters
 * @param {Function} onApplyFilters - Function to apply filters
 * @param {Function} onClearFilters - Function to clear all filters
 * @param {boolean} [embeddedInToolbar=false] - Nested inside glass-toolbar
 */
const ProjectFilterComponent = ({
  filters,
  setFilters,
  onApplyFilters,
  onClearFilters,
  embeddedInToolbar = false,
}) => {
  const [activeKey, setActiveKey] = useState('0');

  const handleFilterChange = (filterKey, value) => {
    setFilters(prev => ({
      ...prev,
      [filterKey]: value,
    }));
    onApplyFilters({ [filterKey]: value });
  };

  const handleClearFilters = () => {
    setFilters({
      status: '',
    });
    onClearFilters();
  };

  const hasActiveFilters = Object.values(filters).some(
    value => value !== '' && value !== null && value !== undefined
  );

  return (
    <div
      className={
        embeddedInToolbar
          ? 'project-filter-panel project-filter-panel--embedded mt-3'
          : 'glass-panel project-filter-panel mb-3'
      }
    >
      <div className="project-filter-panel__header">
        <div className="project-filter-title">
          <FilterList className="project-filter-icon" />
          <strong>Project Filters</strong>
          {hasActiveFilters && (
            <span className="active-filters-indicator">
              {
                Object.values(filters).filter(
                  v => v !== '' && v !== null && v !== undefined
                ).length
              }
            </span>
          )}
        </div>
        {hasActiveFilters && (
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={handleClearFilters}
            className="clear-filters-btn"
          >
            <Clear className="me-1" />
            Clear All
          </Button>
        )}
      </div>
      <div className="project-filter-panel__body">
        <Accordion activeKey={activeKey} onSelect={key => setActiveKey(key)}>
          <AccordionItem eventKey="0">
            <AccordionHeader>Project Status</AccordionHeader>
            <AccordionBody>
              <Form.Group className="status-options">
                <Form.Check
                  key=""
                  type="radio"
                  label="All Statuses"
                  name="status"
                  checked={filters.status === ''}
                  onChange={() => handleFilterChange('status', '')}
                />
                {PROJECT_STATUS_OPTIONS.map(option => (
                  <Form.Check
                    key={option.value}
                    type="radio"
                    label={option.label}
                    name="status"
                    checked={filters.status === option.value}
                    onChange={() => handleFilterChange('status', option.value)}
                  />
                ))}
              </Form.Group>
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </div>
    </div>
  );
};

export default ProjectFilterComponent;
